import { callAuthAPI } from 'react-morel-auth';

export const deletePartner = (partnerId: string | undefined) => {
  return callAuthAPI('/partner/partners/' + partnerId, '', {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
};
